<template>
    <v-dialog v-model="showTaskEstimateDialog"
            persistent
            min-height="80%"
            width="auto">
        <v-card>
            <v-toolbar theme="dark">
                <v-toolbar-title>Set Estimate for {{ dialogJob && dialogJob.name }}</v-toolbar-title>
                <v-btn icon="mdi-close"
                       @click="showTaskEstimateDialog = false"></v-btn>
            </v-toolbar>
            <v-card-text>
                <div>
                    Job has an estimated coating time of {{ convertMinutesToHoursMinutes(dialogJob && dialogJob.originalEstimatedCoatingTime) }}mins.
                </div>
                <v-text-field label="Estimated Percentage to Complete (0 - 100%)"
                              v-model.number="percentageRequired"
                              type="number"
                              class="mt-2"></v-text-field>
                <div v-if="estimatedTime !== null">
                    <h3><small>Estimated time required </small>{{ convertMinutesToHoursMinutes(estimatedTime) }}mins</h3>
                </div>
                <v-alert icon="mdi-alert-decagram-outline"
                         class="my-2"
                         v-if="validationErrors.length > 0"
                         type="warning">
                    <ul class="small-text">
                        <li :key="error" v-for="error in validationErrors">{{ error }}</li>
                    </ul>
                </v-alert>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn @click="saveEstimate"
                       :disabled="validationErrors.length > 0"
                       prepend-icon="mdi-check-circle"
                       color="success">
                    SAVE
                </v-btn>
                <v-btn variant="tonal" @click="showTaskEstimateDialog = false">
                    CANCEL
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped lang="scss">
    @import '../../../styles/smart.scss'
</style>
<script>
    import { mapActions, mapState } from "vuex";
    import { convertMinutesToHoursMinutes } from "../../../mixins/numberMixins";
    function initialState() {
        return {
            percentageRequired: null,
        };
    }
    export default {
        name: "SmartTaskEstimateDialog",
        data: function () {
            return initialState();
        },
        methods: {
            ...mapActions([
                "updateSmartJobTask",
            ]),
            convertMinutesToHoursMinutes,
            saveEstimate() {
                this.updateSmartJobTask({ path: 'estimatedPercentageRequired', value: this.percentageRequired / 100 });
                this.showTaskEstimateDialog = false;
            },
        },
        computed: {
            ...mapState({
                dialogJob: (state) => state.smart.dialogJob,
            }),
            showTaskEstimateDialog: {
                get() {
                    return this.$store.state.smart.showTaskEstimateDialog;
                },
                set(value) {
                    this.$store.commit('setShowTaskEstimateDialog', value);
                }
            },
            estimatedTime() {
                if (this.dialogJob && this.dialogJob.originalEstimatedCoatingTime && this.percentageRequired && !isNaN(parseFloat(this.percentageRequired))) {
                    return this.dialogJob.originalEstimatedCoatingTime * (parseFloat(this.percentageRequired) / 100);
                }
                return null;
            },
            validationErrors() {
                const errors = [];
                const val = parseFloat(this.percentageRequired);
                if (this.percentageRequired === null || this.percentageRequired === '' || isNaN(val)) {
                    errors.push('Percentage is required');
                } else {
                    if (val <= 0) errors.push('Percentage must be greater than 0');
                    if (val >= 100) errors.push('Percentage must be less than 100');
                }
                return errors;
            },
        },
        watch: {
            showTaskEstimateDialog(val) {
                if (val && this.dialogJob) {
                    this.percentageRequired = this.dialogJob.estimatedPercentageRequired ? this.dialogJob.estimatedPercentageRequired * 100 : null;
                }
            }
        }
    };
</script>
